(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/search/assets/javascripts/search.js') >= 0) return;  svs.modules.push('/components/casino/search/assets/javascripts/search.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let trackSearchDelayer;
const {
  createFocusTrap
} = svs.components.lbUtils.focusTrap;
function trackSearchString(str) {
  clearTimeout(trackSearchDelayer);
  if (str && str.length > 1) {
    trackSearchDelayer = setTimeout(() => {
      svs.components.analytics.trackSearch(str, 'Casino');
    }, 2000);
  }
}
const filterKeys = [{
  local: 'category',
  elasticSearch: 'categories'
}, {
  local: 'provider',
  elasticSearch: 'providers'
}, {
  local: 'feature',
  elasticSearch: 'tags'
}];
function constructElasticSearchString(activeFilters, query) {
  const channel = "web-".concat(svs.components.casino.shared.getDeviceType());
  const queryUrl = new svs.content.shared.ContentUrlBuilder('/content/3/casinosearch').addParams({
    count: 5000,
    include: 'result.name',
    channel,
    query: encodeURIComponent(query)
  });
  filterKeys.forEach(filterKey => {
    const typeHasActiveFilters = activeFilters[filterKey.local] && Object.keys(activeFilters[filterKey.local]).length;
    if (typeHasActiveFilters) {
      const filterList = Object.keys(activeFilters[filterKey.local]);
      queryUrl.addParams({
        [filterKey.elasticSearch]: encodeURIComponent(filterList.join(','))
      });
    }
  });
  return queryUrl.build();
}
const MANUAL_ABORT = 'manual_abort';
class Search {
  constructor() {
    this.el = $('#casino-search');
    this.isPnp = svs.core.config.data.svsconfig.site === 'momang';
    this.MIN_SEARCH_INTERVAL_TIME = 500;
    this.lastSearchTime = 0;
    this.debounceTimer = null;
    this.lastSearch = null;
    this.lastFilters = null;
    this.casinoSearchInput = this.el.find('.js-casino-search-input');
    this.casinoInputField = this.el.find('.js-casino-search-input-field');
    this.casinoSearchResetButton = this.el.find('.js-casino-search-reset-button');
    this.searchResult = this.el.find('.js-casino-search-result');
    this.searchFilterPopoverToggle = this.el.find('.js-casino-search-filters-button');
    this.filterClearButton = this.el.find('.js-casino-clear-search-filters-button');
    this.filterCounter = this.el.find('.js-casino-search-filter-count');
    this.gameListTemplate = svs.casino.game_list.templates.game_list;
    this.gameListGridTemplate = svs.casino.game_list.templates.game_list_grid;
    this.filterTemplate = svs.casino.shared.templates.search_filter_popover; 
    this.placeholderTemplate = svs.casino.placeholder.templates.placeholder;
    this.filterExpanded = false;
    this.onAttach();
  }
  addListeners() {
    $(this.casinoSearchResetButton).on('click', () => {
      this.resetInput();
      this.search();
    });
    $(this.filterClearButton).on('click', () => {
      this.clearFilters();
      this.updateFilters();
    });
    let filterOptions = {
      position: 'bottom-left',
      offset: {
        top: 5,
        right: 0
      },
      content: this.filterTemplate({
        isPnp: this.isPnp,
        filters: svs.components.casino.data.searchFilters
      }),
      closeOnOutsideClick: true,
      onHide: () => {
        this.toggleFilterAriaExpanded();
        this.releaseFocus();
      },
      onBeforeShow: () => this.toggleFilterAriaExpanded()
    };
    if (svs.core.detect.formfactor.mobile()) {
      filterOptions = _objectSpread(_objectSpread({}, filterOptions), {}, {
        onBeforeHide: () => document.documentElement.classList.remove('disable-body-scroll'),
        onShow: () => document.documentElement.classList.add('disable-body-scroll')
      });
    }
    this.searchFilterPopoverToggle[0].setAttribute('aria-expanded', this.filterExpanded);
    this.filterPopover = new svs.components.Popover($(this.searchFilterPopoverToggle), filterOptions);
    this.searchFilterPopoverToggle.on('click', e => {
      e.preventDefault();
      this.openFilterPopover();
    });
    $(document).on('click', '.js-casino-search-filter-item input', e => {
      const checkbox = e.currentTarget;
      const filter = checkbox.parentElement.parentElement.dataset.filter;
      const name = checkbox.parentElement.parentElement.dataset.id;
      if (name && filter) {
        if (checkbox.checked) {
          this.addFilter(filter, name);
          svs.components.casino.shared.trackEvent('Checked', 'Filter', name);
        }
        if (!checkbox.checked) {
          this.removeFilter(filter, name);
        }
      }
      this.updateFilters();
    });
    $(document).on('click', '.js-casino-search-filters-popover-clear-button', e => {
      e.preventDefault();
      this.clearFilters();
      this.updateFilters();
    });
    const fixedTopContent = $('.fixed-top-content');
    $(document).on('click', '.js-casino-search-filters-popover-done-button', () => {
      if (svs.core.detect.formfactor.mobile()) {
        $('#find-page').removeAttr('style');
        fixedTopContent === null || fixedTopContent === void 0 || fixedTopContent.css('position', 'static');
      }
      this.filterPopover.toggle();
    });
    this.casinoSearchInput.on('keydown', e => {
      if (e.which === 13) {
        e.preventDefault();
      }
    });
    this.casinoSearchInput.on('input', () => {
      this.updateFilterButtons();
      this.debouncedSearch(this.casinoSearchInput.val());
    });
  }
  openFilterPopover() {
    if (svs.core.detect.formfactor.mobile()) {
      $('#find-page').css('height', '1490px');
      $('#find-page').css('overflow', 'hidden');
    }
    this.filterPopover.toggle();
    this.focusTrap.trapFocus(this.el.find('.js-casino-search-filters')[0]);
    this.updateFilters();
  }
  releaseFocus() {
    this.focusTrap.releaseFocus(this.searchFilterPopoverToggle[0]);
  }
  toggleFilterAriaExpanded() {
    this.filterExpanded = !this.filterExpanded;
    this.searchFilterPopoverToggle[0].setAttribute('aria-expanded', this.filterExpanded);
  }
  clearFilters() {
    Object.keys(svs.casino.activeSearchFilters).filter(key => typeof svs.casino.activeSearchFilters[key] === 'object' && key !== 'sort').forEach(filter => {
      svs.casino.activeSearchFilters[filter] = {};
    });
    svs.casino.activeSearchFilters.count = 0;
  }
  debouncedSearch(str) {
    if (this.jupiterCall && this.jupiterCall.readyState < 4) {
      this.jupiterCall.abort(MANUAL_ABORT);
    }
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.search(str);
    }, this.MIN_SEARCH_INTERVAL_TIME);
  }
  addFilter(filter, name) {
    if (!svs.casino.activeSearchFilters[filter]) {
      svs.casino.activeSearchFilters[filter] = {};
    }
    svs.casino.activeSearchFilters[filter][name] = true;
    svs.casino.activeSearchFilters.count++;
  }
  removeFilter(filter, name) {
    delete svs.casino.activeSearchFilters[filter][name];
    svs.casino.activeSearchFilters.count--;
  }
  setFilterCheckboxes() {
    $(document).find('.js-casino-search-filters').find('input:checkbox').each(function () {
      const el = this.parentElement.parentElement;
      const filter = el.getAttribute('data-filter');
      const name = el.getAttribute('data-id');
      this.checked = svs.casino.activeSearchFilters[filter] && svs.casino.activeSearchFilters[filter][name];
    });
  }
  removeFilterTags() {
    $(document).find('.js-casino-search-filter-tags').find('.js-casino-search-filter-tag').remove();
  }
  updateFilterTags() {
    this.removeFilterTags();
    Object.keys(svs.casino.activeSearchFilters).filter(key => typeof svs.casino.activeSearchFilters[key] === 'object' && key !== 'sort').forEach(filter => {
      Object.keys(svs.casino.activeSearchFilters[filter]).forEach(name => {
        this.el.find('.js-casino-search-filter-tags-container').append($(svs.ui.button.partials.button({
          size: '300',
          title: "".concat(this.isPnp ? '' : '#').concat(name),
          data: {
            filter,
            name
          },
          class: 'casino-search-filter-tag js-casino-search-filter-tag',
          icon: 'close',
          'icon-position': 'right',
          inverted: 'true',
          linkTitle: "Ta bort filter ".concat(name),
          aria: {
            label: "Ta bort filter ".concat(name)
          }
        })));
      });
    });
    $(document).find('.js-casino-search-filter-tag').on('click', e => {
      const el = $(e.target.closest('.js-casino-search-filter-tag'));
      this.removeFilter(el.data('filter'), el.data('name'));
      this.updateFilters();
    });
  }
  updateFilters() {
    this.setFilterCheckboxes();
    this.updateFilterTags();
    document.querySelector('.js-casino-search-result').style.removeProperty('display');
    if (svs.casino.activeSearchFilters.count === 0 && this.casinoSearchInput.val().length === 0) {
      this.hideGameList();
    }
    this.updateFilterButtons();
    this.search();
  }
  updateFilterButtons() {
    const popoverClearButton = this.el.find('.js-casino-search-filters-popover-clear-button');
    popoverClearButton.toggleClass('disabled', svs.casino.activeSearchFilters.count === 0);
    if (!this.isPnp) {
      this.searchFilterPopoverToggle.toggleClass('btn-transparent-inverted', svs.casino.activeSearchFilters.count === 0);
    }
    this.searchFilterPopoverToggle.toggleClass('casino-search-filters-active', svs.casino.activeSearchFilters.count !== 0);
    this.filterClearButton.toggleClass('hide', svs.casino.activeSearchFilters.count < 2);
    this.filterCounter.toggleClass('hide', svs.casino.activeSearchFilters.count === 0).html(svs.casino.activeSearchFilters.count);
    this.casinoInputField.toggleClass('casino-search-input-has-content', this.casinoSearchInput.val().length > 0);
  }
  elasticSearch(str) {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
    if (useLegacyJupiterApi) {
      const options = {
        method: 'GET',
        path: constructElasticSearchString(svs.casino.activeSearchFilters, str)
      };
      this.jupiterCall = svs.core.jupiter.call(options, data => {
        this.updateResults(data.result.map(item => item.name));
      }, error => {
        if (error.statusText !== MANUAL_ABORT) {
          this.updateResults([]);
        }
      });
      return;
    }

    this.jupiterCall = null;
    const channel = "web-".concat(svs.components.casino.shared.getDeviceType());
    const activeFilters = svs.casino.activeSearchFilters;
    const categories = activeFilters.category ? Object.keys(activeFilters.category) : [];
    const providers = activeFilters.provider ? Object.keys(activeFilters.provider) : [];
    const tags = activeFilters.feature ? Object.keys(activeFilters.feature) : [];
    const client = svs.content.shared.getCmsClient();
    client.v1.content.casinoSearch({
      query: str ? encodeURIComponent(str) : undefined,
      categories: categories.length > 0 ? encodeURIComponent(categories.join(',')) : undefined,
      providers: providers.length > 0 ? providers.join(',') : undefined,
      tags: tags.length > 0 ? encodeURIComponent(tags.join(',')) : undefined,
      channels: channel,
      count: 5000,
      include: 'result.name'
    }).then(response => {
      this.updateResults(response.result.map(item => item.name));
    }).catch(() => {
      this.updateResults([]);
    });
  }
  resetInput() {
    this.casinoSearchInput.val('');
    this.updateFilterButtons();
    this.updateResults(null);
  }
  search(str) {
    str = str || this.casinoSearchInput.val() || '';
    clearTimeout(this.debounceTimer);
    const currentFilters = JSON.stringify(svs.casino.activeSearchFilters);
    if (this.lastSearch === str && this.lastFilters === currentFilters) {
      return;
    }
    this.lastFilters = currentFilters;
    this.lastSearch = str;
    svs.casino.activeSearchFilters.q = str;
    if (str.length === 0 && svs.casino.activeSearchFilters.count === 0) {
      this.updateResults();
    } else {
      this.elasticSearch(str);
      trackSearchString(str);
    }
  }
  initGameList() {
    this.gameListInstance = new svs.components.casino.GameList();
  }
  removePlaceholder() {
    if (this.placeholder) {
      this.placeholder.remove();
      delete this.placeholder;
    }
  }
  updateResults(results) {
    svs.components.casino.shared.recordSearchState();
    if (!this.gameListInstance) {
      this.initGameList();
    }
    if (!results) {
      this.hideGameList();
      this.removePlaceholder();
      return;
    }
    if (!results.length) {
      if (this.placeholder) {
        this.placeholder.remove();
      }
      this.placeholder = $(this.placeholderTemplate({
        icon: 'icecream',
        iconSize: '1000',
        title: this.casinoSearchInput.val() ? 'Oj, här var det tomt!' : 'Vi hittar visst inte det du letar efter!',
        information: this.casinoSearchInput.val() ? "Vi hittade inga tr\xE4ffar f\xF6r '".concat(this.casinoSearchInput.val(), "'") : 'Pröva att filtrera på något annat'
      }));
      this.searchResult.append(this.placeholder);
      this.hideGameList();
      return;
    }
    this.removePlaceholder();
    this.showGameList();
    results = results.filter(game => svs.components.casino.data.gameCache.index[game] && svs.components.casino.data.gameCache.index[game].title.substring(0, 5) !== 'TEST-');
    svs.components.casino.game.extendCache(results.map(result => svs.components.casino.data.gameCache.index[result]));
    const renderedGames = svs.core.detect.formfactor.desktop() ? 24 : 8;
    const gameList = results.map((game, index) => {
      if (index < renderedGames) {
        return {
          rendered: true,
          game: svs.components.casino.games[game]
        };
      }
      return game;
    });
    this.gameListInstance.setDefaultGameList(gameList);
    this.gameListInstance.sort(svs.casino.activeSearchFilters.sort);
  }
  onAttach() {
    this.addListeners();
    this.getSearchState();
    this.focusTrap = createFocusTrap({
      refocus: true,
      ariaHiddenElements: ['.casino-search-filters-header-title', '.js-casino-search-input-field', '.js-casino-search-filters-button', '#top-content', '.js-casino-search-result', '.casino-categories', '.form-label-text', '#findContent'],
      selectors: ['button:not([disabled])', 'input[type="checkbox"]:not([disabled])'],
      onEscape: () => {
        this.filterPopover.hide();
        this.releaseFocus();
      }
    });
  }
  getSearchState() {
    svs.components.casino.shared.restoreSearchState(searchState => {
      this.casinoSearchInput.val(searchState.q);
      this.updateFilters();
    });
  }
  hideGameList() {
    this.gameListInstance && this.gameListInstance.hide();
  }
  showGameList() {
    this.gameListInstance && this.gameListInstance.show();
  }
  destroy() {
    $(document).off('keydown', '.js-casino-search-input');
    $(document).off('input', '.js-casino-search-input');
    $(document).off('click', '.js-casino-search-reset-button');
    $(document).off('click', '.js-casino-search-filters-button');
    $(document).off('click', '.js-casino-search-filters-popover-done-button');
    $(document).off('click', '.js-casino-search-filters-popover-clear-button');
    $(document).off('click', '.js-casino-clear-search-filters-button');
    $(document).off('click', '.js-casino-search-filter-item input');
    $(document).off('click', '.js-casino-search-filter-tag .icon');
    document.removeEventListener('keydown', this.handleEscapeKeyDown);
    this.focusTrap.destroy();
    delete this.filterPopover;
  }
}
setGlobal('svs.components.casino.Search', Search);
setGlobal('svs.components.casino.test.Search', Search);

 })(window);